{
  "status": {
    "pending_payment": "待付款",
    "paid": "已付款 — 待出貨",
    "ready_to_ship": "待出貨",
    "exported_to_click_drop": "已匯出至 Click & Drop",
    "shipped": "已出貨",
    "delivered": "已送達",
    "released": "款項已發放",
    "refunded": "已退款",
    "cancelled": "已取消",
    "disputed": "爭議中"
  },
  "disputeStatus": {
    "open": "已開啟",
    "awaiting_seller": "待賣家回應",
    "awaiting_buyer": "待買家回應",
    "under_review": "審核中",
    "resolved_buyer": "已解決（買家）",
    "resolved_seller": "已解決（賣家）",
    "closed": "已結案"
  },
  "disputeReason": {
    "item_not_received": "未收到物品",
    "item_not_as_described": "物品與描述不符",
    "damaged_item": "物品損壞",
    "wrong_item": "寄錯物品",
    "suspected_counterfeit": "懷疑為仿冒品",
    "missing_contents": "內容物缺失",
    "tracking_problem": "追蹤資訊有問題",
    "other": "其他"
  },
  "disputeResolution": {
    "full_refund": "全額退款",
    "partial_refund": "部分退款",
    "replacement": "更換物品",
    "other": "其他"
  },
  "page": {
    "eyebrow": "訂單",
    "title": "您的訂單",
    "subtitle": "追蹤付款、出貨及款項發放狀況。所有金額均以英鎊（GBP）顯示。"
  },
  "tabs": {
    "purchases": "我的購買",
    "sales": "我的銷售",
    "all": "所有訂單（管理員）"
  },
  "loadError": "無法載入訂單：{message}",
  "filtered": "篩選中：",
  "clearFilter": "清除篩選",
  "purchaseType": {
    "buyNow": "即買即拍",
    "auction": "拍賣"
  },
  "clickDrop": {
    "banner": "Royal Mail Click & Drop — 選取已付款訂單、匯出 CSV 檔案，然後上傳至 Click & Drop 購買郵資。",
    "howToImport": "如何匯入",
    "exportSelected": "匯出 {count} 個已選訂單至 CSV"
  },
  "table": {
    "item": "物品",
    "status": "狀態",
    "type": "類型",
    "payout": "款項",
    "total": "總額",
    "actions": "操作",
    "loading": "載入中…",
    "emptyFiltered": "沒有符合所選狀態篩選的訂單。",
    "emptyBuyer": "您尚未得標任何拍賣。",
    "emptySeller": "您尚未售出任何物品。",
    "emptyAdmin": "平台上暫無訂單。",
    "tracking": "追蹤編號：{number}",
    "labelError": "標籤錯誤：{message}",
    "disputeActive": "爭議進行中",
    "payNow": "立即付款",
    "receiptSeller": "銷售發票（PDF）",
    "receiptBuyer": "收據（PDF）",
    "clickDropCsv": "Click & Drop CSV",
    "retryLabel": "重試 Royal Mail 標籤",
    "buyLabel": "購買 Royal Mail 標籤",
    "downloadLabel": "下載並列印標籤",
    "trackParcel": "追蹤包裹",
    "enterTracking": "輸入追蹤編號並出貨",
    "confirmDelivery": "確認已送達",
    "reportProblem": "回報問題",
    "viewDispute": "查看爭議",
    "releasePayout": "發放款項",
    "paidOut": "已發放"
  },
  "toast": {
    "checkoutError": "無法開始結帳",
    "shippedSuccess": "已標記為出貨 — 已通知買家",
    "invoiceError": "無法開啟發票",
    "deliveryReleased": "已確認送達 — 款項已發放予賣家",
    "deliveryProcessing": "已確認送達 — 款項處理中",
    "deliveryConfirmed": "已確認送達",
    "deliveryError": "無法確認送達，請再試一次。",
    "stripeTransferCreated": "已建立 Stripe 轉帳：{id}",
    "exportedMarked": "已標記為已匯出 — 列印標籤後請輸入追蹤編號",
    "labelDuplicate": "此訂單已存在標籤",
    "labelGenerated": "已產生 Royal Mail 標籤 — 已電郵追蹤編號予買家",
    "labelFailed": "標籤產生失敗：{message}",
    "labelOpenError": "無法開啟標籤：{message}",
    "missingAddressWarning": "{count} 張訂單沒有存檔的送貨地址 — 相關 CSV 欄位將留空。",
    "movedUnderReview": "已轉為審核中",
    "evidenceRequested": "已要求提交證據",
    "disputeClosed": "爭議已結案",
    "resolvedSeller": "已判定賣家勝訴 — 款項已發放",
    "resolvedBuyer": "退款已發出",
    "evidenceUploaded": "證據已上傳",
    "invalidRefundAmount": "退款金額無效",
    "disputeResolved": "爭議已解決",
    "disputeOpened": "爭議已提交 — 管理員將會審核"
  },
  "dialogs": {
    "shipment": {
      "title": "輸入追蹤編號並標記為已出貨",
      "description": "請貼上 Royal Mail Click & Drop 標籤上的追蹤編號。儲存後系統會自動電郵通知買家。",
      "trackingLabel": "追蹤編號",
      "trackingPlaceholder": "例如：AB123456789GB",
      "trackingHelp": "此為必填欄位，請輸入 Royal Mail 標籤上列印的追蹤／參考編號。",
      "cancel": "取消",
      "save": "儲存追蹤編號並通知買家"
    },
    "guide": {
      "title": "Royal Mail Click & Drop — 如何匯入 CSV 檔案",
      "description": "BidNova Auctions 會以標準 Click & Drop 範本匯出訂單，讓您可在數分鐘內完成郵資購買。",
      "step1": "登入 business.parcel.royalmail.com，並開啟「Orders → Import orders」。",
      "step2": "選擇 CSV 作為檔案格式，並上傳您剛從 BidNova Auctions 下載的檔案。",
      "step3": "在欄位對應畫面中，選取已儲存的「BidNova Auctions」對應設定（首次上傳後 Click & Drop 會記住此設定 — 我們的欄位標題與其標準範本相符）。",
      "step4": "檢查匯入的訂單，勾選要出貨的項目，然後按「Apply postage」。服務欄位已顯示買家所選的送貨方式。",
      "step5": "列印標籤，於任何郵局投寄或安排收件，然後回到此頁按「輸入追蹤編號並出貨」— 系統會自動電郵通知買家。",
      "tip": "小提示：可批量選取多張已付款訂單並一次匯出 CSV — Click & Drop 會在一次匯入中建立所有訂單。",
      "gotIt": "知道了"
    },
    "label": {
      "title": "建立 Royal Mail 標籤",
      "description": "編輯此訂單的包裹詳情。預設值來自您的送貨設定。",
      "lastAttemptFailed": "上次嘗試失敗",
      "weight": "重量（克）",
      "packageType": "包裹類型",
      "packageTypes": {
        "letter": "信件",
        "largeLetter": "大型信件",
        "smallParcel": "小型包裹",
        "mediumParcel": "中型包裹",
        "parcel": "包裹"
      },
      "service": "送貨服務",
      "length": "長度（毫米）",
      "width": "闊度（毫米）",
      "depth": "深度（毫米）",
      "dimensionsHint": "尺寸為選填項目 — 保持為零將使用包裹類型的預設值。",
      "cancel": "取消",
      "retry": "重試",
      "create": "建立標籤"
    },
    "release": {
      "title": "透過 Stripe Connect 發放款項",
      "description": "是否透過 Stripe Connect 向賣家發放 {amount}？",
      "cancel": "取消",
      "releasing": "發放中…",
      "releaseButton": "透過 Stripe 發放"
    },
    "pay": {
      "title": "選擇送貨方式",
      "description": "請選擇 Royal Mail 服務，運費將計入您的 Stripe 付款。",
      "method": "送貨方式",
      "item": "物品",
      "shipping": "運費",
      "total": "總額",
      "cancel": "取消",
      "redirecting": "跳轉中…",
      "continue": "前往 Stripe 付款"
    }
  },
  "orderDetail": {
    "status": "訂單狀態",
    "shipment": "出貨追蹤",
    "trackingNumber": "追蹤編號",
    "shippedAt": "出貨時間",
    "deliveryConfirmed": "買家已確認送達",
    "yes": "是",
    "no": "否",
    "autoDeliverEligibility": "自動確認送達時間",
    "payout": "款項",
    "saleTotal": "銷售總額",
    "commission": "佣金",
    "sellerPayout": "賣家款項",
    "released": "發放時間",
    "notYet": "尚未發放",
    "stripeTransferId": "Stripe 轉帳編號",
    "disputes": "爭議",
    "adminNote": "管理員備註：{note}",
    "openDisputeCase": "開啟爭議個案",
    "resolveRefundTitle": "退款予買家",
    "resolveReleaseTitle": "發放款項予賣家",
    "resolveDismissTitle": "駁回此爭議",
    "resolveRefundDesc": "將訂單標記為已退款並結束爭議，買家將收到通知。",
    "resolveReleaseDesc": "結束此爭議。待符合送達條件後即可發放款項。",
    "resolveDismissDesc": "結束此爭議，訂單狀態不作任何更改。",
    "resolveNotesLabel": "解決備註（買賣雙方均可查看）",
    "resolveNotesPlaceholder": "請說明此決定，讓買賣雙方了解結果。",
    "cancel": "取消",
    "confirm": "確認",
    "auditLog": "紀錄日誌",
    "auditLogAdmin": "（管理員檢視）",
    "noEvents": "暫無紀錄。",
    "amount": "金額：{amount}",
    "resumeCheckout": "繼續 Stripe 結帳",
    "viewAuction": "查看拍賣"
  },
  "success": {
    "confirming": "正在確認您的付款…",
    "confirmingHint": "請稍候 — 通常只需數秒。",
    "pendingTitle": "付款仍在處理中",
    "pendingFallback": "請稍後再查看。",
    "pendingStatus": "付款狀態：{status}",
    "goToOrders": "前往我的訂單",
    "errorTitle": "發生錯誤",
    "orderReference": "訂單編號：",
    "myOrders": "我的訂單",
    "contactSupport": "聯絡客服",
    "paidTitle": "付款已完成",
    "paidSubtitle": "多謝惠顧 — 賣家已收到通知，將盡快為您出貨。",
    "orderReferenceInline": "訂單編號 {ref}",
    "yourItem": "您的物品",
    "auctionFallback": "拍賣品",
    "itemLabel": "物品",
    "shippingLabel": "運費",
    "totalPaid": "已付總額",
    "viewOrder": "查看訂單",
    "continueBrowsing": "繼續瀏覽",
    "receiptEmailed": "收據及發票已透過電郵發送給您。"
  },
  "orderCentre": {
    "eyebrow": "我的購買",
    "title": "訂單中心",
    "subtitle": "追蹤每張訂單的完整流程。此為唯讀檢視 — 如有問題請使用「聯絡賣家」。",
    "tabs": {
      "active": "進行中",
      "waiting_dispatch": "待出貨",
      "shipped": "已出貨",
      "delivered": "已送達",
      "cancelled": "已取消",
      "returned": "已退回"
    },
    "loading": "載入中…",
    "empty": "此分類中暫無訂單。",
    "table": {
      "orderNumber": "訂單編號",
      "item": "物品",
      "seller": "賣家",
      "amount": "金額",
      "tracking": "追蹤編號",
      "dispatched": "已寄出",
      "delivered": "已送達",
      "rmStatus": "RM 狀態",
      "actions": "操作"
    },
    "auctionItem": "拍賣品",
    "track": "追蹤",
    "invoice": "發票",
    "contact": "聯絡"
  },
  "disputesList": {
    "eyebrow": "爭議中心",
    "title": "您的爭議",
    "subtitle": "追蹤並回應訂單爭議。",
    "loadError": "無法載入爭議：{message}",
    "loading": "載入中…",
    "empty": "暫無爭議。",
    "orderFallback": "訂單",
    "openedOn": "#{id} · 於 {date} 開啟"
  },
  "disputeDetail": {
    "back": "← 所有爭議",
    "orderFallback": "訂單爭議",
    "reference": "爭議 #{disputeId} · 訂單 #{orderId}",
    "salePrice": "成交價：{amount}",
    "shipping": "送貨方式：{method}",
    "tracking": "追蹤編號：{number}",
    "reason": "原因",
    "requestedResolution": "要求的解決方案",
    "description": "說明",
    "adminResolution": "管理員裁決",
    "refund": "退款：{amount}",
    "conversation": "對話紀錄",
    "internalNote": "內部備註",
    "noMessages": "暫無訊息。",
    "messagePlaceholder": "輸入訊息…",
    "internalNoteCheckbox": "內部管理員備註（買賣雙方均不可見）",
    "attachEvidence": "附加證據",
    "send": "傳送",
    "evidence": "證據",
    "noEvidence": "尚未上傳任何證據。",
    "open": "開啟",
    "evidenceMeta": "{role} · {name} · {size} KB",
    "adminActions": "管理員操作",
    "askBuyerEvidence": "要求買家提供更多證據",
    "askSellerEvidence": "要求賣家提供更多證據",
    "moveUnderReview": "轉為審核中",
    "closeNoAction": "結案（不作財務處理）",
    "resolveSellerFavour": "判定賣家勝訴（發放款項）",
    "resolveBuyerFavour": "判定買家勝訴（退款）",
    "closeTitle": "結案（不作財務處理）",
    "resolveSellerTitle": "判定賣家勝訴",
    "resolveBuyerTitle": "判定買家勝訴（退款）",
    "resolveSellerDesc": "此操作將透過 Stripe 向賣家發放款項。",
    "resolveBuyerDesc": "此操作將撤銷先前向賣家的轉帳，並向買家退款。",
    "closeDesc": "此訂單將維持原狀，不會有任何退款或轉帳變更。",
    "refundAmountLabel": "退款金額（英鎊）— 留空則全額退款 {amount}",
    "resolutionNotesLabel": "解決備註（必填，最少 5 個字元）",
    "cancel": "取消",
    "confirm": "確認",
    "closedNotice": "爭議已結案。",
    "loading": "載入中…"
  },
  "timeline": {
    "ariaLabel": "訂單狀態時間軸",
    "placed": "訂單已建立",
    "paid": "付款已確認",
    "preparing": "賣家準備中",
    "preparingHint": "等待賣家出貨",
    "dispatched": "已寄出",
    "inTransit": "運送中",
    "inTransitHint": "追蹤編號 {number}",
    "delivered": "已送達",
    "completed": "已完成",
    "issueReported": "已回報問題",
    "issueHint": "客服正在審核此訂單",
    "inProgress": "進行中"
  },
  "disputeDialog": {
    "title": "回報問題",
    "description": "開啟爭議後，賣家款項將暫停發放，直至管理員審核完畢。",
    "orderLabel": "訂單：{title}",
    "reasonLabel": "原因",
    "reasonPlaceholder": "請選擇原因",
    "resolutionLabel": "您希望的處理結果是？",
    "resolutionPlaceholder": "請選擇解決方案",
    "descriptionLabel": "描述問題",
    "descriptionPlaceholder": "請說明發生的情況（最少 10 個字元）。提交後可於爭議頁面上傳相片。",
    "charCount": "{count}/4000 字元",
    "confirmCheckbox": "我明白此操作將開啟正式爭議，並暫停賣家款項發放。",
    "cancel": "取消",
    "submit": "提交爭議"
  }
}